<template>
  <v-radio-group
    row
    class="imd-sm-radio"
    v-bind="{...$attrs, value}"
    v-on="$listeners"
    >
    <v-radio
      v-for="(item,i) in items_cp" :key="i"
      :label="item.text  || item.value || item"
      :value="item.value || item.text  || item"
    />
  </v-radio-group>
</template>

<!--

  itemsp 사용법

  <i-input-radio v-model="search_type" itemsp="all / 전체 | titl / 제목 | cont / 내용 | name / 작성자 | titl_cont / 제목,내용"/>

-->

<script>
const isDebug = false
export default {
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ['itemsp', 'items', 'value'],
  data () {
    return {
      items_cp : []
    }
  },
  created() {
    if (!this.items && this.itemsp) {

      isDebug && console.log("[i-input-radio] this.itemsp", this.itemsp)

      this.items_cp = this.itemsp.trim()
        .split(/\s*\|\s*/)
        .reduce((p,i)=>{
          const ar = i.split(/\s*\/\s*/);
          p.push({
            'value': ar[0],
            'text' : ar.length > 1 ? ar[1] : ar[0]
          });
          return p
        }, [])

      isDebug && console.log("[i-input-radio] this.items_cp", this.items_cp)

    } else {
      this.items_cp = this.items
    }
  },
  watch : {
    items () {
      this.items_cp = this.items
    }
  }
}
</script>
